// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"check"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.5708 7.37842L10.3785 16.5708L5.42871 11.6211","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CheckIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'check',
    ref,
    icon: element,
  },
));

CheckIcon.displayName = 'CheckIcon';

export default CheckIcon;
